/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
import { formatDistance } from 'date-fns';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { connect } from 'react-redux';
import parsePhoneNumber from 'libphonenumber-js';
import {
  Col,
  Button,
  Dropdown,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap';
import { toast } from 'react-toastify';
import moment from 'moment-timezone';
import {
  editAssignedNumber,
  getPortCallHistory,
  getObiSystemStatus,
  portConfig,
  getPortValues,
  getAssignedNumbers,
  selectBoxDetailsPort,
  getEpikBoxData,
  clearPortConfigChangesMade,
  setPortConfigChangesMade,
  trunkPortConfig,
  getPhysicalStatus,
  obiRebootRequired,
  boundForwardNumber,
  boundRemoveNumber,
  enableDisablePort,
  updateAlarmProtocol,
  updateEpikBoxObi,
  addNote,
  removeAlarmProtocolSettings,
  updateAdvanceModemConfigurations,
  getSelectedPortModal,
  updateNumberRouteAndTrunk,
  selectBoxDetailsObi,
  rebootObi
} from '../../../actions/EpikBoxes';
import {
  cancelAddNumber,
  editNumberCancel,
  updateNumber,
  forceFixNumber,
  getNumberByID,
  getAlarmRelay,
  editNumberFieldChange as editNumberFieldChangeAction,
  getCompanyTollFreeNumbers,
  getObiCallerOverRide
} from '../../../actions/Numbers';
import * as ProvisioningActions from '../../../actions/Provisioning';
import {
  assignRouteInfo,
  getAddress,
  getGateways,
  updateAddress,
} from '../../../actions/Provisioning';
import DeleteModal from '../../DeleteModal';
import AddBoxNumberModal from './AddBoxNumberModal';
import EditBoxNumberModal from './EditBoxNumberModal';
import PortProperty from './PortProperty';
import './selectedPortPanel.css';
import PortConfigModal from './PortConfigModal';
import getObiData from '../../../containers/epikBoxes/helpers';
import SpinnerCircles from '../../Spinner/SpinerCircles';
import Spinner from '../../Spinner/Spinner';
import DropdownSelect, { findSelectedOption } from '../../ProposalGenerator/DropdownSelect';
import { arrayType, evenValues, oddValues, trunkOptions, dialToneOnly } from '../constants';
import {
  assignAction,
  sendBulkActionsToApi,
  unassignAction,
  enableAction,
  disableAction,
  changeAction,
} from '../../../actions/BoxSessionLogging';
import AddSecurityCodeModal from '../../AddSecurityCodeModal';
import CustomModal from '../../CustomModal';
import ForwardNumber from '../../form/ForwardNumber';
import utils from '../../../lib/utils';
import Toggle from '../../Toggle';
import E911AddressModal from '../../E911AddressModal';
import ConfirmationModal from '../../ConfirmationModal';
import WarningModal from '../../WarningModal';
import { TOOLTIPS_TEXT, PENDING_FAX_AVAILABLE } from '../../../lib/constants';
import InfoPopup from '../../InfoPopup';
import ActivateButton from './ActivateButton';
import { isAdminRole } from '../../../lib/utils';
import addBoxAction from '../../../lib/api/addBoxAction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faArrowRight, faArrowLeft, faBackward, faForward } from '@fortawesome/free-solid-svg-icons';
import { setSelectedPortConfigTemplate, getPortConfigTemplates } from '../../../actions/PortConfig';
import {checkSameUserkLockStatus} from '../../../actions/EpikBoxes'
import { Api } from '../../../lib/api/api';
import del from '../../../Res/Icon/delete.png'
import PortRecordingButton from '../../PortRecording/PortRecordingButton';
import { getPermissionForComponent } from '../../../utils/permissionsUtils';

const eDisableEnableAction = {
  ENABLE: 'enable',
  DISABLE: 'disable',
};

const PORT_IS_REBOOTING = 'Please wait 3 minutes while port is rebooting';

const DEFAULT_VALID_TIME_FOR_ENABLE_DISABLE_PORT = 3;

const getConfirmationModalBody = (isEnabling) => {
  if (isEnabling) {
    return 'Enabling the port will require a reboot of the ATA and service will be interrupted on both ports. After reboot this port will be enabled. Are you sure you want to continue?';
  }
  return 'Disabling the port will require a reboot of the ATA and service will be interrupted on both ports. After reboot this port will be disabled. Are you sure you want to continue?';
};

const CONFIRMATION_TYPE_CHANGE = `WARNING: Changing the line type will remove APR settings from this port. Do you wish to continue?`;
class SelectedPortPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editingProperty: null,
      showModal: false,
      showError: false,
      isLoading: false,
      portModal: props.showPortDetail,
      showEditModal: false,
      selectedNumber: '',
      modalStatus: false,
      showHistoryModal: false,
      historyPortCall: [],
      selectedNumberId: null,
      portObiSystemList: [],
      loadingConfig: false,
      loadingCallHistory: false,
      settings: [],
      assignedE911Number: false,
      settingsValidationRules: [],
      extraConfigValues: {},
      settingsVadEnable: false,
      securityCheck: false,
      selectedValue: '',
      wrongSecurityCode: '',
      trunkOptions:
        props.port?.assignedNumberRef?.trunkSelection &&
          props.port?.assignedNumberRef?.trunkSelection !== '1'
          ? trunkOptions.filter(item => item.value !== '1')
          : trunkOptions,
      selectedTrunkOption: findSelectedOption(
        {
          value: props.port?.assignedNumberRef?.trunkSelection,
        },
        trunkOptions,
      ),
      fwdModalState: false,
      fwdNumber: props.port?.assignedNumberRef?.isForwarded
        ? props.port?.assignedNumberRef?.forwardNumbers[0]
        : '+1',
      fwdCheck: !props.port?.assignedNumberRef?.isForwarded,
      portBtnLoading: false,
      portPhysicalData: {},
      monitor: props.port?.monitored || false,
      outbound: props.port?.forceForward || false,
      disabled: props.port?.disabled || false,
      enableDisableLastUpdatedTime: props.port?.enableDisableLastUpdatedTime || false,
      ataWarning: false,
      isEnablingPort: false,
      isEnableDisablePortSecurity: false,
      outboundNumber: props.port?.forceForwardNumber || '',
      outboundNumberBtnLoading: false,
      showOutboundNumInput: false,
      historyStatus: true,
      forceFix: false,
      alarmProtocol: null,
      alarmRelay: null,
      loadingApr: false,
      modifyStatus: false,
      addNote,
      previousType: null,
      typeChangeWarning: false,
      selectedTrunkLabel: null,
      portEnableDisableToggle: null,
      portRebot: false,
      vswitchInfo: null,
      isTollFree: props.port?.assignedNumberRef?.isTollFree || false,
      tollFreeNumbers:  props.port?.assignedNumberRef?.tollFreeNumbers || [],
      unassignedTollFreeNumbers: [],
      selectedNumberNewTollFreeNumber: "",

      //port config related
      portConfigTemplates: null,
      portConfigTemplateLoading: false,
      portConfigurationValues: null,
      implementedPortConfiguration: {},
      showPortConfigModal: false,
      portConfigLoading: false,
      customPortConfigTemplates: null,
      callOveride:false,
      dcUpdatePopup:false,
      SOMETHING_WENT_WRONG:'Something went wrong',
      rebootObiDeviceid:null

    };
    
    // Use instance property to persist port config changes flag across re-renders
    this.portConfigChangesMadeRef = false;

    this.portDetailsFieldProps();
    
    this.boxRef = React.createRef();
    this.updatedPort = '';
    this.editRouteReq = {
      token: null,
    };
    this.token = localStorage.getItem('jwtToken') || null;
  }

  portDetailsFieldProps = (newPort = null) => {
    const { user, boxDetails } = this.props;
    const port = newPort || this.props.port;

    const lastUpdatedDistanceValue = lastUpdated => {
      return lastUpdated
        ? formatDistance(new Date(), new Date(lastUpdated), { addSuffix: true })
        : '-';
    };

    const e911NumberValue = e911Number => !!e911Number;

    this.portDetailsProps = [
      {
        key: 'boxPortNumber',
        prop: 'boxPortNumber',
        label: 'Port Number',
        icon: 'hashtag',
        editable: false,
        hidden: false,
      },
      {
        key: 'portLabel',
        prop: 'portLabel',
        label: 'Port Label',
        icon: 'hashtag',
        value: () => port?.assignedNumberRef?.portLabel || 'No Port Label',
        editable: ((user.role == 'admin' || user.role == 'enterpriseAdmin') && (port?.assignedNumberRef?.number) && !user.readOnly) ? true : false,
        hidden: false,
      },
      {
        key: 'lastUpdated',
        prop: 'lastUpdated',
        label: 'Last Updated',
        icon: 'clock',
        editable: false,
        value: lastUpdatedDistanceValue,
        hidden: false,
      },
      {
        key: 'assignedNumber',
        prop: 'assignedNumber',
        label: 'Assigned Number',
        icon: 'hashtag',
        editable: true,
        hidden: false,
      },
      {
        key: 'e911Number',
        prop: 'e911Number',
        label: 'E911 Number',
        editable: true,
        value: e911NumberValue,
        hidden: !boxDetails?.myEpik || false,
      },
    ];
  }

  onPortLoad = async (newPort = null) => {
    const { getGateways, user, boxDetails, getCompanyTollFreeNumbers } = this.props;

    this.setState({ loadingApr: true });
    this.onPortStatus(newPort);
    this.onAssignedNumber(newPort);
    this.onObiSystemStatus(newPort);

    this.checkHistoryStatus(newPort);
    const tollFreeNumbers = await getCompanyTollFreeNumbers(this.token, boxDetails?.assignedTo?._id);
    if(tollFreeNumbers) {
        this.updateUnassignedTollFreeNumbers(tollFreeNumbers);
    }

    // Moving this call below because it was causing the port to be loaded before the gateways were loaded
    const allowdRoles = [
      "superAdmin",
      "companyGroupAdmin",
      "companyGroupManager",
      "supportEngineer",
    ];
    if (allowdRoles.includes(user?.role)) {
      await getGateways(this.token);
    }
  }

  setSelectedPortConfigTemplateInRedux = async () => {

    const selectedPort = this.props.selectedPort
    let portConfig = {};
    portConfig = { ...selectedPort.appliedConfigTemplate }
    let appliedConfigTemplate = { ...selectedPort.appliedConfigTemplate } // default template values

    const keysToDelete = ['_id', 'name', 'title', '__v', 'default']
    keysToDelete.forEach(key => delete appliedConfigTemplate[key])

    Object.keys(appliedConfigTemplate).map(key => {
      if (!!selectedPort[key])
        appliedConfigTemplate[key] = selectedPort[key] // overwrite with actually implemented values which exists in port
    })
    // add back deleted values
    appliedConfigTemplate = { ...selectedPort.appliedConfigTemplate, ...appliedConfigTemplate }
    this.props.setSelectedPortConfigTemplate(appliedConfigTemplate) //set selected port config template in redux

  }

  setSelectedPortConfigTemplateInRedux = async () => {

    const selectedPort = this.props.selectedPort
    let portConfig = {};
    portConfig = { ...selectedPort.appliedConfigTemplate }
    let appliedConfigTemplate = { ...selectedPort.appliedConfigTemplate } // default template values

    const keysToDelete = ['_id', 'name', 'title', '__v', 'default']
    keysToDelete.forEach(key => delete appliedConfigTemplate[key])

    Object.keys(appliedConfigTemplate).map(key => {
      if (!!selectedPort[key])
        appliedConfigTemplate[key] = selectedPort[key] // overwrite with actually implemented values which exists in port
    })
    // add back deleted values
    appliedConfigTemplate = { ...selectedPort.appliedConfigTemplate, ...appliedConfigTemplate }
    this.props.setSelectedPortConfigTemplate(appliedConfigTemplate) //set selected port config template in redux

  }

  async componentDidMount() {
    const { boxDetails, getEpikBoxData } = this.props;
    await getEpikBoxData(this.token, boxDetails?._id);
    await this.onPortLoad();
    this.setSelectedPortConfigTemplateInRedux();
  }

  async componentDidUpdate(prevProps) {
    const { numbers, port } = this.props;
    if (numbers && prevProps.numbers !== numbers && port?.e911Enabled) {
      this.getNumberAddress();
    }
  }

  updateUnassignedTollFreeNumbers = (tollFreeNumbers = []) => {
    const { port } = this.props;
    const unassignedTollFreeNumbers = tollFreeNumbers.filter(
        (number) => number !== port?.assignedNumberRef?.number
    );
    this.setState({ unassignedTollFreeNumbers});
  };  

  // eslint-disable-next-line react/sort-comp
  getNumberAddress = () => {
    const { numbers, port, getAddress } = this.props;
    const numbersDB = numbers?.allNumbers?.length ? numbers?.allNumbers : [numbers?.numberByID]
    const numberDetails = numbersDB?.filter(item => {
      let portNumber = port?.assignedNumber;
      let number = item?.number;
      if (!portNumber?.includes('+1')) portNumber = '+1' + portNumber;
      if (!number?.includes('+1')) number = '+1' + number;
      return portNumber === number;
    });

    this.setState({ selectedNumberId: numberDetails?.[0]?._id });
    if (numberDetails?.[0]?._id) {
      getAddress(this.token, numberDetails?.[0]?._id);
    }
  };

  // eslint-disable-next-line react/sort-comp
  checkHistoryStatus = (newPort = null) => {
    const port = newPort || this.props.port;
    const { assignedNumberRef } = port;
    if (assignedNumberRef) {
      if (!!port.assignedNumber?.number || port.assignedNumber?.number !== 'N/A') {
        this.setState({
          historyStatus: false,
        });
      } else {
        this.setState({
          historyStatus: true,
        });
      }
    } else {
      this.setState({
        historyStatus: true,
      });
    }
  };

  onPortStatus = async (newPort = null) => {
    this.setState({ portBtnLoading: true });
    const { getPhysicalStatus, boxDetails, getNumberByID, getAlarmRelay } = this.props;
    const port = newPort || this.props.port;
    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const checkObi = Math.ceil(portNumber / 2 - 1);
    const obiId =
      boxDetails?.Obis?.length === 1 ? boxDetails?.Obis[0]?._id : boxDetails?.Obis[checkObi]?._id;
    if (
      port?.assignedNumberRef?.type === 'fireAlarm' ||
      port?.assignedNumberRef?.type === 'alarm'
    ) {
      this.setState({ modifyStatus: true });
      await getAlarmRelay(this.token, boxDetails._id, portNumber);
    }

    let selectedNum = {};
    if (port.assignedNumberRef?._id) {
      selectedNum = await getNumberByID(this.token, port.assignedNumberRef?._id);
    }
    this.setState({ modifyStatus: false });
    const portPhysical = await getPhysicalStatus(this.token, obiId, portNumber);

    let portEnableDisableToggle = this.state.portEnableDisableToggle
    let portRebot = this.state.portRebot
    if (portEnableDisableToggle == null) {
      portEnableDisableToggle = portPhysical.disabled
    }
    else if (!portEnableDisableToggle && !portPhysical.State) {
      portRebot = true
    }
    else {
      portRebot = false
    }
    this.setState({
      loadingApr: false,
      portBtnLoading: false,
      portPhysicalData: portPhysical,
      alarmRelay: selectedNum?.alarmRelayInfo,
      portEnableDisableToggle,
      portRebot
    });
  };

  componentWillReceiveProps(props) {
    const { onConfigResp } = props;
    if (onConfigResp !== null) {
      this.setState({ showError: true });
      this.setState({ isLoading: false });
    } else {
      this.setState({ showError: false });
    }
  }

  onAssignedNumber = async () => {
    const { boxDetails, getAssignedNumbers } = this.props;
    await getAssignedNumbers(
      this.token,
      boxDetails.assignedTo?._id,
      boxDetails.epikBoxUser?._id,
      false,
    );
  };

  confirmCheck = async () => {
    const {
      port,
      boxDetails,
      getEpikBoxData,
      trunkPortConfig,
      onOutsideClick,
      addNote
    } = this.props;
    const { selectedTrunkOption, selectedTrunkLabel } = this.state;

    this.setState({ securityCheck: false });
    const trunkResp = await trunkPortConfig(this.token, {
      vpnAddress: boxDetails?.vpnAddress,
      selectedPort: port?.boxPortNumber
        .split(' ')
        .join('')
        .toLowerCase(),
      number: { ...port?.assignedNumberRef, trunkSelection: selectedTrunkOption },
    });

    if (trunkResp) {
      const obj = {
        note: `Trunk selection updated to ${selectedTrunkLabel} on ${port?.boxPortNumber}`,
        type: 'system',
      };
  
      addNote(this.token, boxDetails._id, obj);
      addBoxAction({ boxID: boxDetails?._id, activity: 'changed Trunk' })
    }
    getEpikBoxData(this.token, boxDetails?._id);
    onOutsideClick();
  };

  onForceFixBtn = async () => {
    const { forceFixNumber, boxDetails, port } = this.props;
    await forceFixNumber(this.token, port?.assignedNumberRef?._id, boxDetails?._id);
  };

  onObiSystemStatus = async (newPort = null) => {
    this.setState({ isLoading: true });
    const { getObiSystemStatus, boxDetails } = this.props;
    const port = newPort || this.props.port;
    const portNumber = port?.boxPortNumber?.replace(/[^0-9]/g, '');
    const obiStatus = await getObiSystemStatus(this.token, boxDetails?._id, portNumber);
    const obiStatusArray =
      typeof obiStatus?.portObiSystemStatus === 'object'
        ? Object.keys(obiStatus?.portObiSystemStatus)
        : [];
    const newPortObiArray = [];
    obiStatusArray?.length > 0 &&
      obiStatusArray.map(item => {
        if (portNumber % 2 === 0) {
          if (item !== 'sp1ServiceStatus') {
            newPortObiArray.push(obiStatus?.portObiSystemStatus[item]);
          }
        } else if (item !== 'sp2ServiceStatus') {
          newPortObiArray.push(obiStatus?.portObiSystemStatus[item]);
        }
      });
    this.setState({
      portObiSystemList: newPortObiArray,
      isLoading: false,
    });
  };

  handleClick = e => {
    if (this.boxRef.current.contains(e.target) || e.target.closest('.boxPortContainer')) {
      return;
    }
    this.props.onOutsideClick();
  };

  configObi = async reset => {
    const { boxDetails, port, portConfig, updatePortConfig } = this.props;
    const updatedPort = { ...port, e911Number: reset ? '' : boxDetails.e911Number };
    const { portKey } = updatedPort;
    boxDetails.Obis[updatedPort.obiIndex][portKey] = updatedPort;
    const portNumber = updatedPort.boxPortNumber.split(' ')[1];
    const body = {
      vpnAddress: boxDetails.vpnAddress,
      selectedPort: portNumber,
      e911Number: updatedPort.e911Number,
      obiObj: boxDetails.Obis[updatedPort.obiIndex],
    };
    const res = await portConfig(this.token, body);
    if (res) {
      this.setState({ portModal: false });
      updatePortConfig();
    }
  };

  onEditPropertyKeyPress = ev => {
    const keyCode = typeof ev.which === 'number' ? ev.which : ev.keyCode;
    const { name } = ev.target;
    const { value, checked } = ev.target;

    // Enter key

    if (name === 'e911Number') {
      this.configObi(!checked);
    } else {
      if (keyCode === 13 || name) {
        if (value === 'Custom') {
          setTimeout(() => {
            this.setState({ showError: false });
          }, 100);
          this.setState({ showModal: true });
        } else {
          if(name == 'portLabel')
            this.props.editNumberFieldChange('portLabel', ev.target.value);
          this.updatedPort = {
            ...this.updatedPort,
            [name]: value,
          };
          for (const propName in this.updatedPort) {
            if (
              this.updatedPort[propName] === null ||
              this.updatedPort[propName] === undefined ||
              this.updatedPort[propName] === ''
            ) {
              delete this.updatedPort[propName];
            }
          }
          this.setState({
            editingProperty: null,
          });
          return;
        }
      }
      // Escape key
      if (keyCode === 27) {
        this.setState({
          editingProperty: null,
        });
      }
    }
  };

  onEditProperty = editingProperty => {
    this.setState({ editingProperty });
  };
  onForceFix = value => {
    this.setState({
      forceFix: value,
    });
  };

  onSelectNumber = ({ suggestion }, vmail) => {
    if (suggestion !== null) {
      this.props.editAssignedNumber(suggestion);
      if(!!!vmail){
        this.props.assignRouteInfo(this.token, suggestion?._id);
      }
      this.setState({
        selectedNumber: suggestion,
        showEditModal: true,
        vmail: !!vmail,
        previousType: suggestion.type,
      });
    }
  };

  onRemoveNumber = async () => {
    const updatedPortData = {
      ...this.props.port,
      ...this.updatedPort,
    };

    for (const propName in updatedPortData) {
      if (
        updatedPortData[propName] === null ||
        updatedPortData[propName] === undefined ||
        updatedPortData[propName] === ''
      ) {
        delete updatedPortData[propName];
      }
    }
    this.updatedPort = '';
    const unassignedNumId = updatedPortData.assignedNumberRef?._id
      ? updatedPortData.assignedNumberRef?._id
      : updatedPortData.assignedNumberRef;
    this.props.onPortUpdate(updatedPortData, unassignedNumId);
    this.setState({ modalStatus: false });
    this.updatedPort = '';
    this.props.onOutsideClick();
  };

  onAddNewNumber = (e, vmail) => {
    this.props.cancelAddNumber();
    this.props.editNumberCancel();
    this.setState({ showAddNumber: e, vmail: !!vmail });
  };
  updateSelectedPortBlockCallerId = newBlockCallerIdValue => {
    // Update the selectedPort prop value in the state
    this.setState(prevState => ({
      selectedPort: {
        ...prevState.selectedPort,
        blockCallerId: newBlockCallerIdValue,
      },
    }));
  };
  renderPortDetailsProperties = () => {
    return this.portDetailsProps.map(({ key, label, icon, editable, value, hidden }) => {
      const shouldShowButton = (key === 'portLabel' && (this.props.port?.assignedNumberRef?.number) &&
        (this.props.user.role === 'admin' ||
        this.props.user.role === 'enterpriseAdmin')) ? true : false;
      return this.props.user.role === 'superAdmin' ||
        this.props.user.role === 'companyGroupAdmin' ||
        this.props.user.role === 'supportEngineer' ||
        this.props.user.role === 'admin' ||
        this.props.user.role === 'enterpriseAdmin' ? (
        <>
      <div key={key} style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ flex: '1 1 auto' }}>
        <PortProperty
          modifyStatus={this.state.modifyStatus}
          handleFwdToggle={() => {
            this.setState({ fwdModalState: true });
          }}
          onOutsideClick={() => this.props.onOutsideClick()}
          boxDetails={this.props.boxDetails}
          onAddNewNumber={this.onAddNewNumber}
          // assignedNumbers={this.props.assignedNumbers}
          onSelectNumber={this.onSelectNumber}
          onRemoveNumber={e => {
            this.setState({ modalStatus: e });
          }}
          deleteMode={this.props.deleteMode}
          user={this.props.user}
          key={key}
          prop={key}
          label={label}
          icon={icon}
          editable={editable}
          hidden={hidden}
          value={value}
          port={this.props.port}
          onEditProperty={this.onEditProperty}
          onEditPropertyKeyPress={this.onEditPropertyKeyPress}
          editing={this.state.editingProperty === key}
          forceFix={this.onForceFix}
          disabled={this.props.incomingFaxes?.isPendingFax}
          callWaitingToggle={this.callWaitingToggle}
        />
        </div>
        {shouldShowButton && !this.props.user?.readOnly &&
        <Button color="primary" 
        className={'port-label-save-btn'}
        onClick={() => {
          this.updatePortNumberData('portLabel',null)}
        }>Save</Button>}
        </div>
        </>
      ) : key !== 'remoteHost' && key !== 'remotePort' ? (
        <PortProperty
          modifyStatus={this.state.modifyStatus}
          onOutsideClick={() => this.props.onOutsideClick()}
          boxDetails={this.props.boxDetails}
          onAddNewNumber={this.onAddNewNumber}
          // assignedNumbers={this.props.assignedNumbers}
          onSelectNumber={this.onSelectNumber}
          onRemoveNumber={e => {
            this.setState({ modalStatus: e });
          }}
          deleteMode={this.props.deleteMode}
          user={this.props.user}
          key={key}
          prop={key}
          label={label}
          icon={icon}
          editable={editable}
          hidden={hidden}
          value={value}
          port={this.props.port}
          onEditProperty={this.onEditProperty}
          onEditPropertyKeyPress={this.onEditPropertyKeyPress}
          editing={this.state.editingProperty === key}
          forceFix={this.onForceFix}
        />
      ) : null;
    });
  };

  onCancel = () => {
    this.setState({ showModal: false });
  };

  onConfirm = () => {
    this.setState({ isLoading: true });
    const updatedPort = {
      ...this.props.port,
      serviceName: 'Custom',
    };
    for (const propName in updatedPort) {
      if (
        updatedPort[propName] === null ||
        updatedPort[propName] === undefined ||
        updatedPort[propName] === ''
      ) {
        delete updatedPort[propName];
      }
    }
    this.setState({
      editingProperty: null,
    });

    this.props.onUploadPortConfig(this.state.uplaodedFile, updatedPort);
  };

  saveUpdatedPort = async (options={}) => {
    const {
      boxDetails,
      updateAlarmProtocol,
      selectedProtocolBody,
      callerIdOverrideValue,
      selectedPort,
      currentSelectedPortConfigTemplate
    } = this.props;
    const { typeChangeWarning } = this.state;
    const updatedPortData = {
      ...this.props.port,
      ...this.updatedPort,
      serviceName: this.props.port?.serviceName,
      blockCallerId: this.props.blockCallerIdConfigValue,
      callerIdOverride: callerIdOverrideValue,
      ...options
    };
    for (const propName in updatedPortData) {
      if (
        updatedPortData[propName] === null ||
        updatedPortData[propName] === undefined ||
        (updatedPortData[propName] === '' && propName !== 'callerIdOverride')
      ) {
        delete updatedPortData[propName];
      }
    }

    if (selectedProtocolBody?.operationMode === 'Live' && !typeChangeWarning) {
      const { selectedNumber } = this.state;

      const alarmProtocol = {
        ...selectedProtocolBody,
        numberID: selectedNumber?._id,
      };
      await updateAlarmProtocol(this.token, boxDetails?._id, alarmProtocol);
    }
    if(this.props.selectedNumberType == dialToneOnly){
      updatedPortData.serviceName = this.props.selectedNumberType
    }
    this.updatedPort = '';

    const appliedConfigTemplate = currentSelectedPortConfigTemplate
    if(appliedConfigTemplate?.showInbandRouteToggle && !selectedPort?.appliedConfigTemplate?.showInbandRouteToggle){
      await this.setInbandRouting(appliedConfigTemplate.inbandRoute)
      if(Object.entries(updatedPortData?.assignedNumberRef).length > 0){
        updatedPortData.assignedNumberRef.inbandRouting = appliedConfigTemplate.inbandRoute;
      }  
    }
    if(appliedConfigTemplate?.showTrunkSelectionToggle && !selectedPort?.appliedConfigTemplate?.showTrunkSelectionToggle){
      await this.updateTrunkSelection(appliedConfigTemplate.trunkSelection)
    }
    // Pass port config changes flag to onPortUpdate (from options, Redux state, instance property, or selectedPort)
    // IMPORTANT: Read from Redux BEFORE calling onPortUpdate, as onPortUpdate might trigger state updates
    const portConfigChangesFromRedux = this.props.portConfigChangesMade;
    const portConfigChangesFromSelectedPort = selectedPort?._portConfigChangesMade;
    updatedPortData.portConfigChangesMade = options.portConfigChangesMade || portConfigChangesFromRedux || this.portConfigChangesMadeRef || portConfigChangesFromSelectedPort;
    
    // Call onPortUpdate FIRST, then clear the state
    this.props.onPortUpdate(updatedPortData);
    
    // Reset the instance property and Redux state AFTER onPortUpdate has read it
    this.portConfigChangesMadeRef = false;
    if (this.props.clearPortConfigChangesMade) {
      this.props.clearPortConfigChangesMade();
    }
    setTimeout(() => {
      this.props.onOutsideClick();


    }, 500);
  };
  updatePortNumberData = async (fieldToUpdate,value) => {
    const assignedNumberRef = this.props.port.assignedNumberRef?._id 
  ? { ...this.props.port.assignedNumberRef, ...this.updatedPort }
  : this.props.port.assignedNumberRef;
  
    const updatedPortData = {
      ...this.props.port,
      assignedNumberRef
    };
    for (const propName in updatedPortData) {
      if (
        updatedPortData[propName] === null ||
        updatedPortData[propName] === undefined ||
        updatedPortData[propName] === ''
      ) {
        delete updatedPortData[propName];
      }
    }
    if(value == null && fieldToUpdate == 'portLabel'){
      value = updatedPortData?.assignedNumberRef?.portLabel
    }
    const res = this.props.updateNumbersData(updatedPortData,fieldToUpdate,value);
    await this.refreshBoxData();
    setTimeout(() => {
      // this.props.onOutsideClick();
    }, 500);
  };

  handleChangeUpload = e => {
    this.setState({ uplaodedFile: e.target.files[0] });
  };

  toggle = () => {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  };

  selectRoute = async (id, body, update = true) => {
    this.props.updateNumberRoute(id, body, true);
  };

  onHistoryCall = async () => {
    const { port, boxDetails, getPortCallHistory } = this.props;
    this.setState({ loadingCallHistory: true });
    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const historyCalls = await getPortCallHistory(this.token, boxDetails?._id, portNumber);
    if (historyCalls.portCallHistory === undefined) {
      toast.error('CALL HISTORY COULD NOT BE FETCHED');
    } else if (historyCalls.portCallHistory === 'CALL HISTORY COULD NOT BE FETCHED') {
      toast.error('CALL HISTORY COULD NOT BE FETCHED');
    } else if (historyCalls.portCallHistory === '' || historyCalls.portCallHistory === null) {
      toast.error('No call history found.');
    } else {
      const portNumber = port.boxPortNumber.split(' ');
      const newArray = [];
      if (
        historyCalls.portCallHistory.CallHistoryFile === '' ||
        historyCalls.portCallHistory === ''
      ) {
        toast.error('No call history found.');
      } else {
        if (!Array.isArray(historyCalls?.portCallHistory?.CallHistoryFile?.CallHistory)) {
          historyCalls.portCallHistory.CallHistoryFile.CallHistory = [
            historyCalls.portCallHistory.CallHistoryFile.CallHistory,
          ];
        }
        historyCalls.portCallHistory.CallHistoryFile.CallHistory.map(item => {
          item.Event.map(itemInner => {
            if (portNumber[1] % 2 === 1) {
              if (itemInner.e0 === 'From PH1' || itemInner.e1 === 'To PH1') {
                newArray.push(item);
              }
            } else if (itemInner.e0 === 'From PH2' || itemInner.e1 === 'To PH2') {
              newArray.push(item);
            }
          });
        });
        if (!newArray.length) toast.error(`No calls found for port ${portNumber[1]}`);
        this.setState({
          historyPortCall: newArray,
          showHistoryModal: !!newArray.length,
        });
      }
    }
    this.setState({ loadingCallHistory: false });
  };

  onPortConfigure = async (fromCustomButton = false, onSuccessCallback = null) => {
    const { getPortValues, port, boxDetails } = this.props;
    await this.setSelectedPortConfigTemplateInRedux();
    const portIdx = port.boxPortNumber.split(' ')[1];
    const obiId = getObiData(port.boxPortNumber, boxDetails, '_id');
    const values = portIdx % 2 === 0 ? evenValues : oddValues;
    this.setState({ loadingConfig: true });
    const res = await getPortValues(this.token, obiId, values);
    if (res) {
      this.setState({
        settings: res?.data?.settings,
        settingsValidationRules: res?.validationRules,
        settingsVadEnable: res?.data?.vadEnable,
        showPortConfigModal: !!res?.data?.settings,
        extraConfigValues: res?.data?.extraConfigValues,
        portConfigOnSuccess: fromCustomButton ? onSuccessCallback : null, // Store callback if from Custom button
      });
    }
    this.setState({ loadingConfig: false });
  };

  validateNumber = async () => {
    const { port, changeAction } = this.props;
    const formattedNumber = parsePhoneNumberFromString(this.state.fwdNumber, 'US');

    if (formattedNumber && ['US', 'CA'].includes(formattedNumber.country)) {
      const body = {
        ...port?.assignedNumberRef,
        isForwarded: true,
        forwardNumbers: [formattedNumber?.number],
      };
      const response = await this.updateFwdNumber(body);
      if (response) {
        // [Action] - Add
        const forwardNumbersString = body?.forwardNumbers?.join(', '); 
        changeAction(`Added forward number ${forwardNumbersString} at ${port?.boxPortNumber}`)
      }
    } else {
      toast.error('Invalid Number');
    }
  };

  removeFwdNumber = async () => {
    const { port, changeAction } = this.props;
    const body = {
      ...port?.assignedNumberRef,
      isForwarded: false,
      forwardNumbers: [],
    };
    const response = await this.updateFwdNumber(body);
    if (response) {
      // [Action] - Delete
      changeAction(`Removed forward number ${this.state.fwdNumber} from ${port?.boxPortNumber}.`)
    }
  };

  updateFwdNumber = async body => {
    const { boxDetails, updateNumber, onOutsideClick, getEpikBoxData } = this.props;

    const response = await updateNumber(this.token, body);
    await getEpikBoxData(this.token, boxDetails?._id);

    this.setState({ fwdModalState: false });
    this.props.onOutsideClick();
    return response;
  };

  monitorToggle = async () => {
    this.setState({ isContainerLoading: true });
    const { port, obiRebootRequired, boxDetails, enableAction } = this.props;
    const { monitor } = this.state;
    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const checkObi = Math.ceil(portNumber / 2 - 1);
    const obiId = boxDetails.Obis[checkObi]?._id;
    const portCheck = portNumber % 2 === 0 ? 'port2' : 'port1';
    const body = {
      [portCheck]: { ...port, monitored: !monitor },
    };
    const response = await obiRebootRequired(this.token, obiId, body);
    if (response) {
      const message = body[portCheck]?.monitored === true ? 'enabled' : 'disabled';
      enableAction(`Monitor ${message} at ${port.boxPortNumber}`)
      this.onClose();
      this.setState({ monitor: !monitor });
      this.props.updatePortConfig();
    }
    this.setState({ isContainerLoading: false });
  };
  
  toggleTollFree = async () => {
    const { isTollFree, tollFreeNumbers } = this.state;
    const { port, updateNumber, addNote, boxDetails, getEpikBoxData, getCompanyTollFreeNumbers, assignedNumbers } = this.props;
  
    const companyId = port?.assignedNumberRef?.company;
  
    const updatedTollFreeStatus = !isTollFree;
  
    if (updatedTollFreeStatus || tollFreeNumbers?.length < 1) {
      this.setState({
        isTollFree: updatedTollFreeStatus,
        tollFreeNumbers: tollFreeNumbers || [],
      });
    } else {
      try {
        const response = await updateNumber(this.token, {
          ...port?.assignedNumberRef,
          tollFreeNumbers: [],
          isTollFree: false,
        });
  
        if (!response) throw new Error("Failed to update Toll Free status");

        this.setState({
          isTollFree: updatedTollFreeStatus,
          tollFreeNumbers: [],
        });
  
        addNote(this.token, port._id, {
          note: "Toll Free disabled and all numbers removed",
          type: "system",
        });
  
        if (companyId) {
          const tollFreeNumbers = await getCompanyTollFreeNumbers(
            this.token,
            companyId
          );
          this.updateUnassignedTollFreeNumbers(tollFreeNumbers);
        }
        await getEpikBoxData(this.token, boxDetails?._id);
      } catch (error) {
        console.error("Error toggling Toll Free:", error);
      }
    }
  };
  
  handleNumberSelect = (event) => {
    this.setState({ selectedNumberNewTollFreeNumber: event.target.value });
  };
  
  
  addNewTollFreeNumber = async () => {
    const { selectedNumberNewTollFreeNumber, tollFreeNumbers } = this.state;
    const { port, updateNumber, addNote, boxDetails, getEpikBoxData, getCompanyTollFreeNumbers, assignedNumbers } = this.props;
  
    const companyId = port?.assignedNumberRef?.company;
  
    if (
      selectedNumberNewTollFreeNumber &&
      !tollFreeNumbers.includes(selectedNumberNewTollFreeNumber) &&
      tollFreeNumbers?.length < 3
    ) {
      const updatedNumbers = [...tollFreeNumbers, selectedNumberNewTollFreeNumber];
      const previousState = { tollFreeNumbers, selectedNumberNewTollFreeNumber };
  
      try {
        const response = await updateNumber(this.token, {
          ...port?.assignedNumberRef,
          tollFreeNumbers: updatedNumbers,
          isTollFree: true,
        });
  
        if (!response) throw new Error("Failed to update toll-free numbers");

        addNote(this.token, boxDetails?._id, {
          note: `Toll Free number ${selectedNumberNewTollFreeNumber} added to port ${port.boxPortNumber}`,
          type: "system",
        });
  
        if (companyId) {
          const tollFreeNumbers = await getCompanyTollFreeNumbers(this.token, companyId);
          this.updateUnassignedTollFreeNumbers(tollFreeNumbers);
        }
  
        this.setState({
          tollFreeNumbers: updatedNumbers,
          selectedNumberNewTollFreeNumber: "",
        });
        await getEpikBoxData(this.token, boxDetails?._id);
      } catch (error) {
        console.error("Error adding toll-free number:", error);
        this.setState(previousState);
      }
    }
  };

  removeTollFreeNumber = async (number) => {
    const { tollFreeNumbers } = this.state;
    const { port, updateNumber, addNote, boxDetails, getEpikBoxData, getCompanyTollFreeNumbers, assignedNumbers } = this.props;
  
    const companyId = port?.assignedNumberRef?.company;
    const updatedNumbers = tollFreeNumbers.filter((n) => n !== number);
    const previousState = { tollFreeNumbers, isTollFree: tollFreeNumbers?.length > 0 };
  
    try {
      const response = await updateNumber(this.token, {
        ...port?.assignedNumberRef,
        tollFreeNumbers: updatedNumbers,
        isTollFree: updatedNumbers?.length > 0,
      });
  
      if (!response) throw new Error("Failed to update toll-free numbers");
  
      // Add a system note based on the updated numbers
      const noteMessage = updatedNumbers?.length
        ? `Toll Free number ${number} removed from port ${port.boxPortNumber}`
        : `Toll Free disabled and all numbers removed from port ${port.boxPortNumber}`;
      addNote(this.token, boxDetails?._id, { note: noteMessage, type: "system" });
  
      this.setState({ tollFreeNumbers: updatedNumbers, isTollFree: updatedNumbers?.length > 0 });

      if (companyId) {
        const tollFreeNumbers = await getCompanyTollFreeNumbers(this.token, companyId);
        this.updateUnassignedTollFreeNumbers(tollFreeNumbers);
      }
      await getEpikBoxData(this.token, boxDetails?._id);
    } catch (error) {
      console.error("Error removing toll-free number:", error);
      this.setState(previousState);
    }
  };
  
  

  callWaitingToggle = async () => {
    console.log("cLL waiting value ", )
    this.setState({ isContainerLoading: true });
    const { port, obiRebootRequired, boxDetails } = this.props;
    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const checkObi = Math.ceil(portNumber / 2 - 1);
    const obiId = boxDetails.Obis[checkObi]?._id;
    const portCheck = portNumber % 2 === 0 ? 'port2' : 'port1';
    const body = {
      [portCheck]: { ...port, callWaiting: !port?.callWaiting },
    };
    const response = await obiRebootRequired(this.token, obiId, body);
    if (response) {
      this.onClose();
      this.props.updatePortConfig();
    }
    this.setState({ isContainerLoading: false });
  };

  onClose = () => {
    this.updatedPort = '';
    this.props.onOutsideClick();
  };

  openSecurityModalForEnableDisablePortToggle = () =>
    this.setState(prev => ({
      ...prev,
      securityCheck: true,
      isOutboundSecuriety: false,
      isEnableDisablePortSecurity: true,
    }));

  openWarningModal = () => {
    const { box } = this.props;
    const { disabled } = this.state;
    
    // Determine if we're enabling or disabling the port
    const isEnabling = disabled; // If currently disabled, we're enabling it

    this.setState(prev => ({
      ...prev,
      ataWarning: true,
      isEnablingPort: isEnabling,
    }));
  }

  handleConfirmRecordingWarning = () => {
    this.setState(prev => ({
      ...prev,
      ataWarning: true,
      isEnablingPort: false, // Default to false for recording warnings
    }));
  }

  closeWarningModal = () =>
    this.setState(prev => ({
      ...prev,
      ataWarning: false,
      isEnablingPort: false,
      typeChangeWarning: false,
      isContainerLoading: false,
    }));

  closeWarningModalAndOpenSecurityModal = () => {
    this.closeWarningModal();
    this.openSecurityModalForEnableDisablePortToggle();
  };

  resetSecurityModalSettings = () =>
    this.setState(prev => ({
      ...prev,
      isOutboundSecuriety: false,
      isEnableDisablePortSecurity: false,
    }));

  getObiDataForEnablingDisablingPort = () => {
    const { port, boxDetails } = this.props;

    const { disabled } = this.state;

    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const checkObi = Math.ceil(portNumber / 2 - 1);
    const obiId = boxDetails.Obis[checkObi]?._id;

    // if mode is disabled then i will send api for enabled mode and vice versa
    const mode = disabled ? eDisableEnableAction.ENABLE : eDisableEnableAction.DISABLE;
    return {
      obiId,
      port: portNumber,
      boxId: boxDetails?._id,
      mode,
    };
  };

  closeSecurityModal = () => {
    this.setState(prev => ({ ...prev, securityCheck: false }));
  };

  refreshBoxData = async () => {
    const { boxDetails, getEpikBoxData } = this.props;
    await getEpikBoxData(this.token, boxDetails?._id);
    this.closeSecurityModal();
  };

  showErrorToaster = () => {
    toast.info(PORT_IS_REBOOTING);
  };

  enableDisableToggle = async () => {
    const { enableDisablePort, port, changeAction } = this.props;
    const { enableDisableLastUpdatedTime } = this.state;

    this.resetSecurityModalSettings();

    const payload = this.getObiDataForEnablingDisablingPort();

    let minutesRelativeToLastChangedTime = DEFAULT_VALID_TIME_FOR_ENABLE_DISABLE_PORT;
    if (enableDisableLastUpdatedTime) {
      minutesRelativeToLastChangedTime = utils.getTimeDifferenceInMinutes(
        enableDisableLastUpdatedTime,
      );
    }

    console.info({ minutesRelativeToLastChangedTime, enableDisableLastUpdatedTime });

    if (minutesRelativeToLastChangedTime < 3) {
      this.showErrorToaster();
      this.closeSecurityModal();
      return;
    }

    const updatedTime = await enableDisablePort(payload);

    if (!updatedTime) {
      this.closeSecurityModal();
      return;
    }

    await this.refreshBoxData();

    const { mode } = payload;
    const updatedValue = mode === eDisableEnableAction.DISABLE;
    const portNumber = port?.boxPortNumber?.replace(/[^0-9]/g, '');
    const message = !updatedValue ? 'Enabled' : 'Disabled'
    changeAction(`Port ${portNumber} status updated to  ${message}`)
    this.setState(prev => ({
      ...prev,
      disabled: updatedValue,
      portEnableDisableToggle: updatedValue,
      enableDisableLastUpdatedTime: updatedTime,
      portRebot: false
    }));
    await this.onPortStatus();
    await this.onObiSystemStatus()
  };

  outboundToggle = async () => {
    const { outbound } = this.state;
    this.setState({
      securityCheck: false,
      isOutboundSecuriety: false,
      isEnableDisablePortSecurity: false,
    });
    const { port, boxDetails, boundRemoveNumber, getEpikBoxData, changeAction } = this.props;
    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const checkObi = Math.ceil(portNumber / 2 - 1);
    const obiId = boxDetails.Obis[checkObi]?._id;
    if (outbound) {
      const body = {
        port: `port${portNumber}`,
        obiId,
      };
      this.setState({ outboundNumberBtnLoading: true });
      const res = await boundRemoveNumber(this.token, boxDetails?._id, body);
      const portResponse = res && res[`${port?.portKey}`]
      if (res && portResponse && !portResponse?.forceForward && !portResponse?.forceForwardNumber) { 
        const removedOutBoundNumber = boxDetails?.Obis?.[checkObi][`${port?.portKey}`]?.forceForwardNumber
        changeAction(`Outbound Number ${removedOutBoundNumber} removed from port  ${portNumber}`)
        this.setState({ outbound: false, outboundNumber: '' });
      }
      await getEpikBoxData(this.token, boxDetails?._id);
      this.setState({ outboundNumberBtnLoading: false });
    } else {
      this.setState({ outbound: true });
    }
  };

  onOutboundChange = e => {
    const { target } = e;
    if (!isNaN(target.value)) {
      this.setState({ outboundNumber: target.value });
    }
  };
  onOutboundNumber = async () => {
    const { port, boxDetails, boundForwardNumber, getEpikBoxData, changeAction } = this.props;
    const { outboundNumber } = this.state;
    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const checkObi = Math.ceil(portNumber / 2 - 1);
    const obiId = boxDetails.Obis[checkObi]?._id;
    if (outboundNumber) {
      const body = {
        port: `port${portNumber}`,
        number: outboundNumber,
        obiId,
      };
      this.setState({ outboundNumberBtnLoading: true });
      const response = await boundForwardNumber(this.token, boxDetails?._id, body);
      const portResponse = response && response[`${port?.portKey}`]
      if (portResponse && portResponse?.forceForward && portResponse?.forceForwardNumber) {
        changeAction(`Outbound Number ${portResponse?.forceForwardNumber} set at port ${port?.boxPortNumber}`)
        this.setState({ outbound: portResponse?.forceForward, outboundNumber: portResponse?.forceForwardNumber, showOutboundNumInput: false });
      }
      this.setState({ outboundNumberBtnLoading: false });
      await getEpikBoxData(this.token, boxDetails?._id);
    } else {
      toast.error('Invalid Number');
    }
  };

  updateNumberAddress = async e => {
    const { numbers, port, updateAddress, clearAddress, boxDetails, addNote, changeAction } = this.props;
    const numbersDB = numbers?.allNumbers?.length ? numbers?.allNumbers : [numbers?.numberByID];
    const numberDetails = numbersDB?.filter(
      number => number?.number === port?.assignedNumber,
    );
    const updatedAddress = await updateAddress(this.token, numberDetails[0]?._id, e);
    clearAddress();
    if (updatedAddress?.statusCode === '200') {
      const message =
        port.e911Enabled === true || port.e911Enabled === 'true' ? 'updated' : 'enabled';
      const obj = {
        note: `e911 ${message} on ${port.boxPortNumber}`,
        type: 'system',
      };
      const logs = Object.entries(e)
      .map(
        ([field, value]) =>
          `<li>"${field}" set to "${value || 'null'}".</li>`
      )
      .join('');
      const log = `e911 ${message} on ${port.boxPortNumber}:<ul>${logs}</ul>`;
      addNote(this.token, boxDetails._id, obj);
      changeAction(log)
      this.postE911Update(port?.assignedNumber, true, e);
    }
    this.setState({ assignedE911Number: false });
  };

  onRemoveAddress = async () => {
    const { selectedNumberId } = this.state;
    const { removeNumberAddress, port, box, addNote, changeAction } = this.props;
    const withoutPlusOne = port?.assignedNumber.split('+1');
    const body = { dn: withoutPlusOne[1] };
    // const remove = await removeNumberAddress(this.token, selectedNumberId, body);
    const remove = { statusCode: '200' }
    if (remove?.statusCode === '200') {
      const obj = {
        note: `e911 removed from ${port.boxPortNumber}`,
        type: 'system',
      };
      addNote(this.token, box._id, obj);
      changeAction(`e911 removed from ${port.boxPortNumber}`)
      this.postE911Update(box?.e911Number, false,null);
    }
    this.setState({ assignedE911Number: false });
    this.onClose();
  };

  postE911Update = async (number, status, e911) => {
    const { updateObi, portConfig, getEpikBoxData, port, box } = this.props;
    const updatedPort = {
      ...port,
      e911Number: number,
      e911Enabled: status,
    };
    const portNumber = updatedPort.boxPortNumber.split(' ')[1];
    const body = {
      vpnAddress: box.vpnAddress,
      selectedPort: portNumber,
      e911Number: updatedPort.e911Number,
      obiObj: box.Obis[updatedPort.obiIndex],
    };
    const foundObi = box.Obis.find(obi => {
      return (
        (obi.port1 && obi.port1.boxPortNumber === updatedPort.boxPortNumber) ||
        (obi.port2 && obi.port2.boxPortNumber === updatedPort.boxPortNumber)
      );
    });
    if (foundObi) {
      if(e911){
        const e911Number = e911?.dn
        const carrier = e911Number?.length && e911Number[0]?.e911Carrier || '';
        updatedPort.e911Info =  { ...e911, vendor: carrier };
      }else{
        if (updatedPort && updatedPort.e911Info) {
          delete updatedPort.e911Info;
          delete updatedPort.e911Number;
      }
      }
      if (foundObi?.port1?.boxPortNumber === updatedPort.boxPortNumber) {
        const { connected, ...updatedNew } = updatedPort;
        foundObi.port1 = updatedNew;
      } else {
        const { connected, ...updatedNew } = updatedPort;
        foundObi.port2 = updatedNew;
      }
    }
    const changedPort = portNumber % 2 === 0 ? 'port2' : 'port1';
    const updatedObi = { ...foundObi, changedPort };
    await updateObi(
      this.token,
      updatedObi,
      box.epikBoxUser._id,
      (updatedPort.assignedNumberRef && updatedPort.assignedNumberRef._id) ||
      updatedPort.assignedNumberRef,
    );
    await portConfig(this.token, body);
    await getEpikBoxData(this.token, box?._id);
  };

  onE911Update = () => {
    const { assignedE911Number } = this.state;
    this.setState({ assignedE911Number: !assignedE911Number });
  };

  updateAdvanceModemConfig = async selectedPortType => {
    const {
      boxDetails,
      selectedPort,
      advModemConfigValue,
      updateAdvanceModemConfigurations,
      addNote,
      changeAction,
    } = this.props;
    const usedToType = ['alarm', 'fireAlarm', 'modem', 'secureEntry', 'elevator', 'modemHunt'];

    if (!usedToType.includes(selectedPortType)) return;

    const { _id: bId } = boxDetails;
    const port = selectedPort.portKey
      .split(`port`)
      .pop()
      .trim();
    const { Obis } = boxDetails;
    const obiPort = `${selectedPort.portKey}`;

    const findSelectedObi = obi => {
      return selectedPort?.assignedNumberRef?._id === obi[obiPort]?.assignedNumberRef?._id;
    };

    const isObiSelected = Obis.find(findSelectedObi);
    if (!isObiSelected) return;

    if (
      (!isObiSelected[obiPort]?.advancedModemConfiguration && !advModemConfigValue) ||
      isObiSelected[obiPort]?.advancedModemConfiguration === advModemConfigValue
    )
      return;

    const payload = {
      obiId: isObiSelected._id,
      mode: advModemConfigValue,
      port,
      lineType: selectedPortType,
    };

    const result = await updateAdvanceModemConfigurations(this.token, bId, payload);

    if (result) {
      const message = advModemConfigValue === true ? 'enabled' : 'disabled';
      const obj = {
        note: `Advanced Modem Configuration ${message} on ${selectedPort.boxPortNumber}`,
        type: 'system',
      };
      addNote(this.token, bId, obj);
      changeAction(`Advanced Modem Configuration ${message} on ${selectedPort.boxPortNumber}`)
    }
  };

  // linetype change model save handler
  onConfirmSave = async (options={}) => {
    const { selectedNumberType, user, saveNumber, getSelectedPortModal, updateNumberRouteAndTrunk, boxDetails, callerIdMasking, callerIdMaskingNumber } = this.props;
    const { previousType, vmail } = this.state;
    // [Action]- Edit Old
    await getSelectedPortModal('edit-old');

    if (callerIdMasking && (!callerIdMaskingNumber || callerIdMaskingNumber.trim() === '' || callerIdMaskingNumber === undefined)) {
      toast.error('Select Caller ID Masking number ');
      return; 
    }
    // [Action]- All Bulk Actions
    if (selectedNumberType === 'unassigned') {
      toast.error('Line type is required');
    } else {
      const selectedPortType = selectedNumberType;
      const previousPortType = previousType;
      if (
        (previousPortType === 'fireAlarm' || previousPortType === 'alarm') &&
        (selectedPortType !== 'alarm' && selectedPortType !== 'fireAlarm')
      ) {
        if (this.state.alarmRelay?.operationMode === 'Live') {
          this.setState({ typeChangeWarning: true, isContainerLoading: true });
        } else {
          this.setState({ isContainerLoading: true });
          this.updateTypeAndRemoveAPRSettings();
        }
      } else {
        await saveNumber('vmailType');
        if (user.role !== 'admin' && !vmail) {
          // Merge portConfigChangesMade from Redux into options if not already present
          if (!options.portConfigChangesMade) {
            const portConfigChangesFromRedux = this.props.portConfigChangesMade;
            if (portConfigChangesFromRedux) {
              options.portConfigChangesMade = portConfigChangesFromRedux;
            }
          }
          this.saveUpdatedPort(options);
          await this.updateAdvanceModemConfig(selectedPortType);
          await updateNumberRouteAndTrunk(this.token, boxDetails._id)
        } else {
          this.props.onOutsideClick();
        }
      }
    }
  };

  updateTypeAndRemoveAPRSettings = async () => {
    const { boxDetails, removeAlarmProtocolSettings, saveNumber, user } = this.props;
    const { selectedNumber, vmail } = this.state;
    const { _id, alarmRelayInfo } = selectedNumber;

    await saveNumber('vmailType');
    if (user.role !== 'admin' && !vmail) {
      this.saveUpdatedPort();
      await this.updateAdvanceModemConfig();
    } else {
      this.props.onOutsideClick();
    }

    const alarmProtocol = {
      alarmRelayInfo,
      _id,
    };

    await removeAlarmProtocolSettings(this.token, boxDetails?._id, alarmProtocol);

    this.setState({
      typeChangeWarning: true,
      isContainerLoading: false,
    });
  };

 unLockBoxButton = async () => {
  const {boxDetails} = this.props
    const element = document.getElementById('test-lock-icon');
    if (element) {
      element.click();
    } else {
      console.error('Element with id "test-lock-icon" not found.');
    }
    await new Promise(resolve => setTimeout(resolve, 1000));
  };
  onPortsNavigateHandler = async (action = "") => {
    const {
      boxDetails,
      port,
      selectPort,
      selectObi,
    } = this.props;
  
    this.onClose();
  
    const currentPort = parseInt(port?.boxPortNumber?.split(" ")[1], 10);
  
    let newPortNumb = currentPort;
    if (action === "next" && currentPort < boxDetails?.Obis.length * 2) {
      newPortNumb = currentPort + 1;
    } else if (action === "prev" && currentPort > 1) {
      newPortNumb = currentPort - 1;
    } else if (action === "first") {
      newPortNumb = 1;
    } else if (action === "last") {
      newPortNumb = boxDetails?.Obis.length * 2;
    }
  
    const newObi = boxDetails.Obis.find((obi) => {
      return (
        (obi.port1 && obi.port1.boxPortNumber === `Port ${newPortNumb}`) ||
        (obi.port2 && obi.port2.boxPortNumber === `Port ${newPortNumb}`)
      );
    });
  
    const newPort =
      Object.values(newObi).find(
        (port) => port.boxPortNumber === `Port ${newPortNumb}`
      ) || null;
  
    selectPort({ ...newPort, lastUpdated: boxDetails?.lastUpdated });
  
    this.portDetailsFieldProps(newPort);

    selectObi(newObi);
  
    this.setState({
      trunkOptions:
        newPort?.assignedNumberRef?.trunkSelection &&
        newPort?.assignedNumberRef?.trunkSelection !== "1"
          ? trunkOptions.filter((item) => item.value !== "1")
          : trunkOptions,
      selectedTrunkOption: findSelectedOption(
        {
          value: newPort?.assignedNumberRef?.trunkSelection,
        },
        trunkOptions
      ),
      outboundNumber: newPort?.forceForwardNumber || '',
      monitor: newPort?.monitored || false,
      isTollFree: newPort?.assignedNumberRef?.isTollFree || false,
      tollFreeNumbers: newPort?.assignedNumberRef?.tollFreeNumbers || [],
      unassignedTollFreeNumbers: [],
      selectedNumberNewTollFreeNumber: "",
    });
  
    this.onPortLoad(newPort);
  };

  updateTrunkSelection = async (selectedTrunk , selectedTrunkLabel) =>{
    const {
      port,
      boxDetails,
      getEpikBoxData,
      trunkPortConfig,
      addNote
    } = this.props;
    const { selectedTrunkOption } = this.state;
    console.log('mian selectedTrunkLabel',selectedTrunkLabel);

    this.setState({ securityCheck: false });
    const trunkResp = await trunkPortConfig(this.token, {
      vpnAddress: boxDetails?.vpnAddress,
      selectedPort: port?.boxPortNumber
        .split(' ')
        .join('')
        .toLowerCase(),
      number: { ...port?.assignedNumberRef, trunkSelection: selectedTrunk },
    },false);

    if (trunkResp) {
      const obj = {
        note: `Trunk selection updated to ${selectedTrunkLabel} on ${port?.boxPortNumber}`,
        type: 'system',
      };
      addNote(this.token, boxDetails._id, obj);
      addBoxAction({ boxID: boxDetails?._id, activity: 'changed Trunk' })
    }
    getEpikBoxData(this.token, boxDetails?._id);
  }

  setInbandRouting = async (inbandRoute) =>{
    const fieldToUpdate = 'inbandRouting'
    await this.updatePortNumberData(fieldToUpdate,inbandRoute);
    await this.props.getNumberByID(this.token, this.props.port.assignedNumberRef?._id);

  }
  getObiForSelectedPort = (boxDetails, selectedPort) => {
    if (!boxDetails?.Obis?.length) return null;
    const obi = boxDetails.Obis[selectedPort.obiIndex];  
    const port = obi?.[selectedPort.portKey];            
    return { obi, port, portKey: selectedPort.portKey, obiIndex: selectedPort.obiIndex };
  };
  obiReboot = async deviceId => {
    const {rebootObi,selectedPort,boxDetails}= this.props
    const { obi, port } = await this.getObiForSelectedPort(boxDetails, selectedPort);
    const response = await rebootObi(this.token, deviceId ? deviceId : obi?.deviceId);
    
  };
  
  handleRebootObi = obi => {
    const divElement = document.getElementById("test-time-remaining");
    const isHidden = divElement?.getAttribute("hidden") !== null;
    if (isHidden) {
      this.setState({ dcUpdatePopup: true });
    }
    else {
      const { selectedObi } = this.props;
      this.setState({ confirmModalStatus: true })
      this.setState({ rebootObiDeviceid: selectedObi?.deviceId })
    }
  };
  render() {
    const {
      port,
      onConfigResp,
      boxDetails,
      gateways,
      user,
      box,
      updatePortConfig,
      selectedNumberType,
      assignAction,
      sendBulkActionsToApi,
      selectedNumberPro,
      addressModalData,
      getSelectedPortModal,
      incomingFaxes,
      getEpikBoxData,
      selectedPort,
      numbers,
      editedNumber
    } = this.props;

    const {
      historyPortCall,
      portObiSystemList,
      isLoading,
      showPortConfigModal,
      loadingConfig,
      loadingCallHistory,
      settings,
      settingsValidationRules,
      settingsVadEnable,
      extraConfigValues,
      vmail,
      trunkOptions,
      selectedTrunkOption,
      portPhysicalData,
      portBtnLoading,
      outbound,
      outboundNumber,
      showOutboundNumInput,
      monitor,
      disabled,
      outboundNumberBtnLoading,
      historyStatus,
      isContainerLoading,
      selectedNumber,
      alarmRelay,
      loadingApr,
      ataWarning,
      typeChangeWarning,
      currentSelectedPortConfigTemplate,
      isTollFree,
      tollFreeNumbers,
      unassignedTollFreeNumbers,
      selectedNumberNewTollFreeNumber,
      callOveride
    } = this.state;
    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const portCheck = portNumber % 2 === 0 ? 'Port 2' : 'Port 1';
    const displayTimeZone = utils.getUserDisplayTimeZone();
    const displayTimeZoneAbbr = moment().tz(displayTimeZone).format('z');
    const portEnableDisabledClass = disabled
      ? 'd-flex red-disabled'
      : 'd-flex red-container brighter';
    const historyButton = (
      // <div>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '10px' }}>
        <Button
          color="primary"
          onClick={this.handleRebootObi}
        >
          Reboot ATA
        </Button>
        <PortRecordingButton
          port={port}
          boxDetails={boxDetails}
          user={user}
        />
        {utils.showActivate(port, boxDetails, user) ? <ActivateButton port={port} disabled={incomingFaxes?.isPendingFax} /> : null}
        { !box?.myEpik &&  !isAdminRole(user.role) ? (
          <Button
            disabled={loadingConfig || incomingFaxes?.isPendingFax}
            color="primary"
            style={{ marginRight: '10px' }}
            onClick={this.onPortConfigure}
          >
            {loadingConfig ? <SpinnerCircles /> : 'Port Configuration'}
          </Button>
        ) : null}
        <Button color="primary" onClick={this.onHistoryCall} disabled={historyStatus || incomingFaxes?.isPendingFax || loadingCallHistory}>
          {loadingCallHistory ? <SpinnerCircles /> : 'Port Call History'}
        </Button>
      </div>
    );
    // const deleteModalMsg = `${
    //   selectedNumberType === 'fax' ? 'This change will remove all associated email addresses.' : ''
    // } Do you really want to unassign the number ?-- 11${callOveride } ? Do you really want to unassign the number ?--22 `;

    const deleteModalMsg =
    (selectedNumberType === 'fax'
      ? 'This change will remove all associated email addresses. '
      : '') +
    'Do you really want to unassign the number?' +
    (port && port.vmBox != null ? ' Removing this number will also remove associated voicemail settings. Do you want to continue?' : '') +
    (callOveride ? ' This number is already linked with Caller ID.' : '');
    const disablePrevPortBtn = this.props?.port?.boxPortNumber === 'Port 1';
    const disableNextPortBtn = this.props?.port?.boxPortNumber === `Port ${this.props?.boxDetails?.Obis?.length * 2}`;
    const canAddMoreNumbers = tollFreeNumbers?.length < 3;

    const canEnableDisablePort = getPermissionForComponent('enableDisablePort', user.permissionsGroup);
    const canOutboundOverride = getPermissionForComponent('outboundOverride', user.permissionsGroup);
    const canTrunkSelection = getPermissionForComponent('trunkSelection', user.permissionsGroup);

    return (
      <div id="selected-port-details" ref={this.boxRef}>
        {showPortConfigModal && 
        <PortConfigModal
          port={port}
          updatePortConfig={updatePortConfig}
          boxDetails={boxDetails}
          settings={settings}
          settingsValidationRules={settingsValidationRules}
          // settingsVadEnable={settingsVadEnable}
          settingsVadEnable={currentSelectedPortConfigTemplate?.showVadToggle ? currentSelectedPortConfigTemplate.vadEnable : settingsVadEnable}
          isOpen={showPortConfigModal}
          refresh={this.onPortConfigure}
          isClose={() => {
            this.setState({ showPortConfigModal: false, portConfigOnSuccess: null });
            // Don't reset the ref here - only reset after Save is called
          }}
          updateTrunkSelection={this.updateTrunkSelection}
          onTrunckSelection={e => {
            this.setState({ selectedTrunkOption: trunkOptions.find(option => option.value === e) });
          }}
          setInbandRouting={this.setInbandRouting}
          inbandRouting={this.props.numbers?.numberByID?.inbandRouting || false}
          selectedTrunkOption={selectedTrunkOption}
          extraConfigValues={extraConfigValues}
          isMainModalAction={true}
          onPortConfigSuccess={this.state.portConfigOnSuccess}
          onPortConfigChangesMade={(changesMade) => {
            // Store in instance property to persist across re-renders
            this.portConfigChangesMadeRef = changesMade;
            console.log('Port config changes made flag set to:', changesMade);
          }}
          setPortConfigChangesMade={setPortConfigChangesMade}
        />
        }
        <Modal isOpen={this.state.showModal}>
          <ModalHeader>Service Name</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Configuration File:</Label>
              <Input
                type="file"
                accept=".config"
                onChange={this.handleChangeUpload}
                name="imagePage"
              />
            </FormGroup>
            {this.state.showError ? (
              onConfigResp.omitted && Object.keys(onConfigResp.omitted).length ? (
                <div>
                  <Dropdown isOpen={this.state.dropdownOpen} toggle={() => this.toggle()}>
                    <DropdownToggle caret>Click To see Omitted Values</DropdownToggle>
                  </Dropdown>

                  <div style={{ padding: '20px' }} hidden={!this.state.dropdownOpen}>
                    {Object.keys(onConfigResp.omitted).join(', ')}
                  </div>
                </div>
              ) : null
            ) : null}
          </ModalBody>
          <ModalFooter>
            <Button outline color="secondary" onClick={this.onCancel}>
              Cancel
            </Button>
            <Button color="primary" disabled={this.state.isLoading} onClick={this.onConfirm}>
              {!this.state.isLoading ? 'Submit' : 'Loading'}
            </Button>
          </ModalFooter>
        </Modal>

        <Modal className="medium-box-modal" isOpen={this.state.portModal}>
          <ModalHeader close={historyButton}>
            {port?.assignedNumberRef?.type || 'Unassigned'}
          </ModalHeader>
          <ModalBody>
            {isContainerLoading && <Spinner />}
            {incomingFaxes?.isPendingFax && <p className=' error-message error-blink '>{PENDING_FAX_AVAILABLE}</p>}
            <Row>
              {/* left column of model open on port click */}
              <Col md={6}>{this.renderPortDetailsProperties()}</Col>

              <Col md={6}>
                <div className="obi-status-view">
                  <FormGroup row>
                    <Label for="showCallRecording" sm={8}>
                      Original Provisioned Date:
                    </Label>
                    <Col md={12}>
                      {utils.getDateTimeFormat(this.props.port?.provisionDate, 'both')}
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Label for="showCallRecording" sm={8}>
                      Last Updated: 
                    </Label>
                    <Col md={12}>
                      <span style={{ color: this.props.port?.updatedOn && utils.isOlderThan24Hours(this.props.port.updatedOn) ? 'red' : undefined, fontWeight: this.props.port?.updatedOn && utils.isOlderThan24Hours(this.props.port.updatedOn) ? 500 : undefined }}>
                        {utils.getDateTimeFormat(this.props.port?.updatedOn, 'both')}
                      </span>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col md={12}>
                      <div style={{ backgroundColor: '#888888' }}>
                        <p
                          style={{
                            margin: '2px 0px 2px 0px',
                            color: '#ffffff',
                            fontWeight: 'bold',
                          }}
                        >
                          Port Status:
                        </p>
                      </div>
                      {
                        !this.state.portRebot ?
                          !!Object.keys(portPhysicalData).length &&
                        Object.entries(portPhysicalData)?.map(([key, value]) => {
                          if (key.includes("disabled")) return null
                          return (
                            <div className="port-row">
                              <p style={{ margin: '0px' }}>{utils.toTitleCase(key)}: </p>
                              <p style={{ margin: '0px' }}>{value}</p>
                            </div>
                          );
                        })
                          : <div className='d-flex flex-column'>
                            <p>{PORT_IS_REBOOTING}</p>
                            <div className="loading-btn-spinner" style={{ alignSelf: 'center' }} />
                          </div>
                      }
                    </Col>
                    <Col md={12} className="refresh-port">
                      <Button color="primary" onClick={() => this.onPortStatus()} disabled={portBtnLoading}>
                        {!portBtnLoading ? 'Refresh' : <div className="loading-btn-spinner" />}
                      </Button>
                    </Col>
                  </FormGroup>

                  {portObiSystemList.length > 0 &&
                    portObiSystemList.map(item => {
                      const itemObi = Object.values(item);
                      return (
                        <FormGroup row>
                          <Col md={12}>
                            <div>
                              <div style={{ backgroundColor: '#888888' }}>
                                <p
                                  style={{
                                    margin: '2px 0px 2px 0px',
                                    color: '#ffffff',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  {item.placeHolder}:
                                </p>
                              </div>
                              {itemObi.map(innerItem => {
                                return (
                                  innerItem !== item.placeHolder && (
                                    <p style={{ margin: '0px' }}>{innerItem}</p>
                                  )
                                );
                              })}
                            </div>
                          </Col>
                        </FormGroup>
                      );
                    })}

                  <Button
                    color="primary"
                    onClick={() => this.onObiSystemStatus()}
                    disabled={!(portObiSystemList.length > 0 && !isLoading)}
                    style={{ float: 'right' }}
                  >
                    {!isLoading ? 'Refresh EPI' : <div className="loading-btn-spinner" />}
                  </Button>
                </div>
                <FormGroup row style={{ marginBottom: '0px ' }}>
                  <Label for="name" sm={8} className="d-flex">
                    Monitor:
                    <sup>
                      <InfoPopup id="port-monitor" text={TOOLTIPS_TEXT.MONITOR} />
                    </sup>
                  </Label>
                  <Col md={12} className="d-flex">
                    <Toggle value={monitor} onToggle={this.monitorToggle} disabled={incomingFaxes?.isPendingFax} />
                    <span className="ml-2">{this.props.port.boxPortNumber}</span>
                  </Col>
                </FormGroup>
                {!boxDetails.myEpik && (canOutboundOverride === 'write' || canOutboundOverride === 'both') && (
                  <FormGroup style={{ marginBottom: '0px ' }} row>
                    <Label for="name" sm={12} className="d-flex">
                      Outbound Number Override:
                      <sup>
                        <InfoPopup id="outbound-number" text={TOOLTIPS_TEXT.OUTBOUND_OVERRIDE} />
                      </sup>
                    </Label>
                    <Col md={12} className="d-flex">
                      <Toggle
                        // value={(outboundNumber && outbound) || showOutboundNumInput}
                        value={(outboundNumber &&  this.props?.port?.forceForward) || showOutboundNumInput}
                        disabled={incomingFaxes?.isPendingFax}
                        onToggle={() => {
                          return (!isAdminRole(user.role) && outboundNumber && outbound && !showOutboundNumInput) 
                            ? this.setState({ securityCheck: true, isOutboundSecuriety: true })
                            : !isAdminRole(user.role) ? this.setState({ showOutboundNumInput: !showOutboundNumInput, outboundNumber: '' }) : null
                        }}
                      />
                      {outboundNumber && <span className="ml-2 text-decoration-underline" style={{color:'blue'}}>
                        {parsePhoneNumber(outboundNumber, 'US')?.number}
                      </span>}
                      {(outboundNumberBtnLoading && !showOutboundNumInput) && <SpinnerCircles red />}
                    </Col>
                    {!isAdminRole(user.role) && showOutboundNumInput && (
                      <Col md={12} className="d-flex flex-row p-3">
                        { 
                          !outboundNumberBtnLoading && <Input
                            placeholder="Please specify"
                            required
                            type="text"
                            name="outboundNumber"
                            value={outboundNumber}
                            maxLength={10}
                            onChange={this.onOutboundChange}
                          />
                        }
                        <Button
                          color="primary"
                          disabled={outboundNumberBtnLoading || incomingFaxes?.isPendingFax}
                          onClick={this.onOutboundNumber}
                        >
                          {!outboundNumberBtnLoading ? (
                            'Submit'
                          ) : (
                            <div className="loading-btn-spinner" />
                          )}
                        </Button>
                      </Col>
                    )}
                  </FormGroup>
                )}
                {port?.assignedNumberRef?.number && (canEnableDisablePort === 'write' || canEnableDisablePort === 'both') && (
                  <>
                    <FormGroup style={{ marginBottom: '0px ' }} row>
                      <Label for="name" sm={8} style={{ color: '#dc3545' }} className="d-flex">
                        {/* Port: {portPhysicalData.disabled ? 'Disabled' : 'Enabled'} */}
                        Port: {!(this.state.portEnableDisableToggle) ? 'Enabled' : 'Disabled'}
                        <sup>
                          <InfoPopup id="port-enabled" text={TOOLTIPS_TEXT.PORT_ENABLE} />
                        </sup>
                      </Label>
                      <Col md={12}>
                        <div className="toggle-wrapper">
                          {/* <Toggle
                            // value={!portPhysicalData.disabled}
                            value={!(this.state.portEnableDisableToggle)}
                            redSides
                          //   onToggle={() => {
                          //     return !isAdminRole(user.role) ? this.openWarningModal() : null;
                          //   }}
                          //   disabled={portBtnLoading || incomingFaxes?.isPendingFax}
                          //   customDisableText={`Please wait for the port to load`}
                          // /> */}
                          <Toggle
                            value={!(this.state.portEnableDisableToggle)}
                            redSides
                            onToggle={async () => {
                              const { boxDetails } = this.props;
                              try {
                                let response = await this.props.checkSameUserkLockStatus(
                                  this.token,
                                  boxDetails?._id
                                );
                                if (response === false) {
                                  toast.error(this.state.SOMETHING_WENT_WRONG);
                                  return; 
                                }
                                if (response && response?.ErrorMessage) {
                                  if (response.ErrorMessage === "Record is not locked for editing") {
                                    const divElement = document.getElementById("test-time-remaining");
                                    const isHidden = divElement?.getAttribute("hidden") !== null;
                                    if (isHidden) {
                                      this.setState({ dcUpdatePopup: true });
                                    } else {
                                      return !isAdminRole(user.role) ? this.openWarningModal() : null;
                                    }
                                  } else {
                                    toast.error(response && response?.ErrorMessage);
                                    return;
                                  }
                                } else {
                                  const divElement = document.getElementById("test-time-remaining");
                                  const isHidden = divElement?.getAttribute("hidden") !== null;
                                  if (isHidden) {
                                    this.setState({ dcUpdatePopup: true });
                                  } else {
                                    return !isAdminRole(user.role) ? this.openWarningModal() : null;
                                  }
                                }
                              } catch (err) {
                                console.error("Lock check failed:", err);
                                toast.error("Something went wrong while checking lock");
                              }
                            }}
                            disabled={portBtnLoading || incomingFaxes?.isPendingFax}
                            customDisableText={`Please wait for the port to load`}
                          />
                          {portBtnLoading && (
                            <div className="toggle-spinner">
                              <SpinnerCircles red />
                            </div>
                          )}
                        </div>
                      </Col>
                    </FormGroup>
                    <FormGroup style={{ marginBottom: '0px ' }} row>
                      {loadingApr ? (
                        <div className="d-flex">
                          <Label for="name" sm={8} style={{ color: '#dc3545' }}>
                            Checking APR...
                          </Label>
                          <SpinnerCircles red />
                        </div>
                      ) : (
                        alarmRelay?.operationMode === 'Live' && (
                          <Label
                            for="name"
                            sm={12}
                            style={{ color: '#dc3545', fontWeight: 'bold' }}
                          >
                            APR is Enabled
                          </Label>
                        )
                      )}
                    </FormGroup>
                  </>
                )}
                {!isAdminRole(user.role) && (
                  <>
                    <FormGroup row style={{ marginBottom: '0px' }}>
                      <Label for="name" md={12} className="pr-0">
                        Use Port Assigned Number for e911:
                      </Label>
                    </FormGroup>
                    <Row className="ml-1">
                      <Button color="primary" onClick={this.onE911Update} disabled={incomingFaxes?.isPendingFax}>
                        {port.e911Enabled ? 'Update/Remove Address' : 'Use Port e911'}
                      </Button>
                    </Row>
                  </>
                )}
                 {utils.filterCustomer(user.role) && (
                   <FormGroup row style={{ marginTop: "12px" }}>
                    <Label for="name" sm={8} className="d-flex">
                      Toll Free:
                    </Label>
                    <Col md={12} className="d-flex">
                      <Toggle value={isTollFree} onToggle={this.toggleTollFree} />
                      {(canAddMoreNumbers && isTollFree) && (
                          <>
                            <select
                              className="form-control tollfree-select"
                              name="select"
                              value={selectedNumberNewTollFreeNumber}
                              onChange={this.handleNumberSelect}
                            >
                              <option value="" disabled>
                                Select a number
                              </option>
                              {unassignedTollFreeNumbers.map((item) => (
                                <option key={item?._id} value={item}>
                                  {item}
                                </option>
                              ))}
                            </select>
                            <Button
                              style={{ height: '28px', marginLeft: '4px', display: 'flex', 
                                alignItems: 'center' }}
                              onClick={this.addNewTollFreeNumber}
                              disabled={!selectedNumberNewTollFreeNumber || !port?.assignedNumberRef}
                              color="primary"
                            >
                              +
                            </Button>
                          </>
                        )}
                    </Col>
                    {isTollFree && (
                      <>
                        {tollFreeNumbers?.length > 0 && (
                          <Col md={12} style={{ marginTop: "8px", marginLeft: '20px' }}>
                            <ul>
                              {tollFreeNumbers?.map((number) => (
                                <li key={number} className="d-flex mb-1" style={{ width: '70%', justifyContent: 'space-between', alignItems: 'center' }}>
                                  {number}
                                  <img className="actions-icon" src={del} alt="delete"  onClick={() => this.removeTollFreeNumber(number)} 
                                   style={{ height: '24px' }}
                                  />
                                </li>
                              ))}
                            </ul>
                          </Col>
                        
                        )}
                      </>
                    )}
                  </FormGroup>
                 )}
              </Col>
            </Row>
            {!box.myEpik && (canTrunkSelection === 'write' || canTrunkSelection === 'both') && (
              <Row
                style={{ marginLeft: '0px', marginRight: '30px' }}
                hidden={
                  port?.assignedNumberRef?.type !== 'modem' &&
                  port?.assignedNumberRef?.type !== 'faxStandard' &&
                  port?.assignedNumberRef?.type !== 'fireAlarm' &&
                  port?.assignedNumberRef?.type !== 'alarm' && 
                  
                  !(
                    (port?.assignedNumberRef?.type === 'voice' && selectedPort.appliedConfigTemplate?.showTrunkSelectionToggle) ||
                    (port?.assignedNumberRef?.type === 'hunt' && selectedPort.appliedConfigTemplate?.showTrunkSelectionToggle)
                  )
                }
              >
                <Col md={{ size: '6' }}>
                  <InputGroup style={{ flexWrap: 'nowrap' }}>
                    <InputGroupAddon
                      addonType="prepend"
                      style={{ height: 'calc(1.5em + 0.75rem + 2px)' }}
                    >
                      <InputGroupText>
                      <FontAwesomeIcon 
                        icon={faCog} 
                        className="fa-cog" 
                      />
                      </InputGroupText>
                    </InputGroupAddon>
                    <DropdownSelect
                      disabled={isAdminRole(this.props.user.role) || incomingFaxes?.isPendingFax}
                      selectedOption={selectedTrunkOption}
                      options={trunkOptions}
                      onSelect={async (option) => {
                        this.setState({
                          selectedTrunkOption: option,
                          selectedTrunkLabel: option.label,
                          trunkOptions: trunkOptions.filter(item => item.value !== '1'),
                        });
                        await this.updateTrunkSelection(option.value, option.label);
                      }}
                    />
                  </InputGroup>
                </Col>
              </Row>
            )}
            {/* </div> */}
          </ModalBody>
          <ModalFooter style={{ flexWrap: 'nowrap' }}>
            <Button onClick={() => this.onPortsNavigateHandler('first')} color="primary" disabled={disablePrevPortBtn}>
              <FontAwesomeIcon icon={faBackward} className="fa-arrow-left" />
            </Button>
            <Button onClick={() => this.onPortsNavigateHandler('prev')} color="primary" disabled={disablePrevPortBtn}>
              <FontAwesomeIcon icon={faArrowLeft} className="fa-arrow-left" />&ensp;
              Previous Port
            </Button>
            <Button onClick={this.onClose} color="primary" id="port-close-btn">
              Close
            </Button>
            {this.state.forceFix && (
              <Button color="danger" onClick={this.onForceFixBtn}>
                Force Fix
              </Button>
            )}
            <Button onClick={() => this.onPortsNavigateHandler('next')} color="primary" disabled={disableNextPortBtn}>
              Next Port&ensp;
              <FontAwesomeIcon icon={faArrowRight} className="fa-arrow-right" />
            </Button>
            <Button onClick={() => this.onPortsNavigateHandler('last')} color="primary" disabled={disableNextPortBtn}>
              <FontAwesomeIcon icon={faForward} className="fa-arrow-left" />
            </Button>
          </ModalFooter>
        </Modal>
        <AddSecurityCodeModal
          isOpen={this.state.securityCheck}
          onCancel={() => {
            this.setState({
              securityCheck: !this.state.securityCheck,
              wrongSecurity: !this.state.wrongSecurityCode,
              isOutboundSecuriety: false,
              isEnableDisablePortSecurity: false,
            });
          }}
          onConfirm={() => {
            const { isOutboundSecuriety, isEnableDisablePortSecurity } = this.state;
            if (isOutboundSecuriety) {
              this.outboundToggle();
            } else if (isEnableDisablePortSecurity) {
              this.enableDisableToggle();
            } else {
              this.confirmCheck();
            }
          }}
          trunkCode={!this.state.isOutboundSecuriety}
          enableDisablePortCode={!!this.state.isEnableDisablePortSecurity}
          multiCode={this.state.isOutboundSecuriety}
          // modalName='outboundremoval'
          featureName={
            this.state.isEnableDisablePortSecurity ? 'enableDisablePortCode' :
              this.state.isOutboundSecuriety ? "outBoundSecuriety" : 'trunkCode'
          }
        />

        {/* WARNING MODAL WHEN PORT IS DISABLED/ENABLED */}
        <ConfirmationModal
          isOpen={ataWarning || typeChangeWarning}
          onCancel={this.closeWarningModal}
          onConfirm={
            ataWarning
              ? this.closeWarningModalAndOpenSecurityModal
              : this.updateTypeAndRemoveAPRSettings
          }
          bodyText={ataWarning ? getConfirmationModalBody(this.state.isEnablingPort) : CONFIRMATION_TYPE_CHANGE}
          confirmBtnText="Continue"
        />

        {/* <--- History Call Modal ---> */}

        <Modal isOpen={this.state.showHistoryModal}>
          <ModalHeader>{`Port Call History (${displayTimeZoneAbbr})`}</ModalHeader>
          <ModalBody style={{ height: '400px', overflow: 'auto' }}>
            {historyPortCall.length > 0 &&
              historyPortCall.map((historyItem, historyIdx) => {
                const epiTz = boxDetails?.epiTimezone;
                const headerFmt = utils.formatPortCallHistoryDateTime(
                  historyItem['-date'],
                  historyItem['-time'],
                  epiTz
                );
                return (
                  <div key={`port-call-history-${historyIdx}`}>
                    <div style={{ backgroundColor: '#888888' }}>
                      <p
                        style={{ margin: '2px 0px 2px 0px', color: '#ffffff', fontWeight: 'bold' }}
                      >
                        {headerFmt
                          ? `${headerFmt.time} · ${headerFmt.date}`
                          : `${historyItem['-time']} date: ${historyItem['-date']}`}
                      </p>
                    </div>
                    {historyItem.Event.map((ev, evIdx) => {
                      const evFmt = utils.formatPortCallHistoryDateTime(
                        historyItem['-date'],
                        ev['-time'],
                        epiTz
                      );
                      return (
                        <div
                          key={`port-call-history-ev-${historyIdx}-${evIdx}`}
                          style={{ display: 'flex', justifyContent: 'space-between' }}
                        >
                          <div style={{ display: 'flex' }}>
                            <p style={{ margin: '0px 5px 0px 0px', color: 'blue' }}>
                              {evFmt ? evFmt.time : ev['-time']}
                            </p>
                            <p style={{ margin: '0px' }}>{ev.e0}</p>
                          </div>
                          <p style={{ margin: '0px' }}>{ev.e1}</p>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
          </ModalBody>
          <ModalFooter>
            <Button
              outline
              color="secondary"
              onClick={() => {
                this.setState({ showHistoryModal: false });
              }}
            >
              Close
            </Button>
          </ModalFooter>
        </Modal>

        {/* <--- End History Call Modal ---> */}
        <EditBoxNumberModal
          selectRoute={(id, body, update = false) => {
            this.selectRoute(id, body, update);
          }}
          vmail={vmail}
          gateways={gateways}
          boxDetails={boxDetails}
          selectedNumber={this.state.selectedNumber}
          isOpen={this.state.showEditModal}
          onCancel={() => {
            this.setState({ showEditModal: false });
            this.props.setSelectedPortConfigTemplate({})
          }}
          props={this.props}
          onConfirm={this.onConfirmSave}
          onRemoveNumber={async (e) => {
            let getData = await this.props.getObiCallerOverRide(this.token, boxDetails?._id, selectedNumber?.number, false);
            if (getData && Object.keys(getData).length > 0) {
              this.setState({ callOveride: true });
            }
            this.setState({ modalStatus: e });
          }}
          updateTrunkSelection={this.updateTrunkSelection}
          onTrunckSelection={e => {
            this.setState({ selectedTrunkOption: trunkOptions.find(option => option.value === e) });
          }}
          setInbandRouting={this.setInbandRouting}
          onTypeChangeRemoveNumber={e => {this.onRemoveNumber(e)}}
          updatePort = {(options = {}) => {
            // Include port config changes flag from options (passed from EditBoxNumber), Redux state, or instance property
            // Prioritize: options > Redux > ref
            const portConfigChangesFromRedux = this.props.portConfigChangesMade;
            const portConfigChanges = options.portConfigChangesMade !== undefined ? options.portConfigChangesMade : (portConfigChangesFromRedux || this.portConfigChangesMadeRef);
            return this.saveUpdatedPort({ ...options, portConfigChangesMade: portConfigChanges });
          }}
          onPortConfigure={this.onPortConfigure}
        />
        <AddBoxNumberModal
          selectRoute={(id, body, update = false) => {
            this.selectRoute(id, body, update);
          }}
          gateways={gateways}
          vmail={vmail}
          boxDetails={boxDetails}
          isOpen={this.state.showAddNumber}
          onCancel={() => this.onAddNewNumber(false)}
          props={this.props}
          onConfirm={async editMode => {
            await getSelectedPortModal('add-new');
            // [Action]- All Bulk Actions
            if (selectedNumberType === 'unassigned') {
              toast.error('Line type is required');
              return
            } 
            else {
              if (editMode) {
                if(selectedNumberType != dialToneOnly)
                  await this.props.saveNumber(vmail);
                if (!vmail) {
                  this.saveUpdatedPort();
                } else {
                  this.props.onOutsideClick();
                }
              } else {
                this.props.onAddNumber();
                this.onAddNewNumber(false);
              }
            }
          }}
          onEditPropertyKeyPress={this.onEditPropertyKeyPress}
          port={port}
        />

        <E911AddressModal
          onRemoveAddress={this.onRemoveAddress}
          isOpen={this.state.assignedE911Number}
          selectedNumberTitle={port?.assignedNumber}
          data={addressModalData?.entry_query}
          onCancel={() => {
            this.setState({ assignedE911Number: false });
            this.props.clearAddress();
            this.onClose();
          }}
          onUpdate={async e => {
            await this.updateNumberAddress(e);
            await this.getNumberAddress();
            await getEpikBoxData(this.token, boxDetails._id);
            this.onClose();
          }}
          port={port}
        />

        <DeleteModal
          message={deleteModalMsg}
          isOpen={this.state.modalStatus}
          onCancel={() => this.setState({ modalStatus: false })}
          onConfirm={this.onRemoveNumber}
        />

        <CustomModal
          header="Forward Number"
          onConfirm={this.state.fwdCheck ? this.validateNumber : false}
          isOpen={this.state.fwdModalState}
          onCancel={() => this.setState({ fwdModalState: false })}
        >
          <ForwardNumber
            fwdCheck={this.state.fwdCheck}
            fwdNumber={this.state.fwdNumber}
            onDeleteFwdNumber={this.removeFwdNumber}
            handleChange={e => {
              this.setState({ fwdNumber: e });
            }}
          />
        </CustomModal>
        <ConfirmationModal
          bodyText={'You are attempting to make changes to a device that is not currently locked for editing. To prevent conflicting changes, please lock the device before proceeding.'}
          headerText={'Device Lock Required'}
          confirmBtnText={'Lock & Edit'}
          close={'No'}
          isOpen={this.state.dcUpdatePopup}
          onCancel={() => {
            this.setState({ dcUpdatePopup: false });
          }}
          onConfirm={() => {
            this.unLockBoxButton('add');
            this.setState({ dcUpdatePopup: false });
          }}
        />
           <ConfirmationModal
          bodyText={'Warning! Proceeding with rebooting the EPI will cause service disruption to any line configured on this port are you sure you want to continue?'}
          headerText={'Are you sure?'}
          confirmBtnText={'Proceed'}
          close={'No'}
          isOpen={this.state.confirmModalStatus}
          onCancel={() => {
            this.setState({ confirmModalStatus: false });
          }}
          onConfirm={() => {
            this.unLockBoxButton('add');
            this.setState({ dcUpdatePopup: false });
            this.setState({ confirmModalStatus: false });
            this.obiReboot(this.state.rebootObiDeviceid)
          }}
        />
      </div>
    );
  }
}

SelectedPortPanel.propTypes = {
  port: PropTypes.object,
  onPortUpdate: PropTypes.func,
};

const mapStateToProps = state => ({
  editedNumber: state.UIState.numbers.editNumber,
  onConfigResp: state.AppState.obis.unassignedObis.obiResp || null,
  assignedNumbers: state.AppState.obis.assignedNumbers || [],
  user: state.AppState.user,
  deleteMode: state.AppState.deleteMode,
  gateways: state.AppState.provisioning.gateways,
  obiSystemStatus: state.AppState.boxDetails.obiSystemStatus,
  box: state.AppState.boxDetails.box,
  selectedNumberType: state.UIState.numbers.editNumber.type,
  callerIdMasking: state.UIState.numbers.editNumber.callerIdMasking,
  callerIdMaskingNumber: state.UIState.numbers.editNumber.callerIdMaskingNumber,
  addressModalData: state.AppState.provisioning.address,
  numbers: state.AppState.numbers,
  selectedNumberPro: state.AppState.numbers.numberByID,
  selectedProtocolBody: state.UIState.epikBoxes.selectedProtocolBody,
  advModemConfigValue: state.AppState.boxDetails.advModemConfigValue,
  callerIdOverrideValue: state.AppState.boxDetails.callerIdOverrideValue,
  selectedPort: state.UIState.epikBoxDetails.selectedPort,
  selectedObi: state.UIState.epikBoxDetails.selectedObi,
  incomingFaxes: state.AppState.faxes.incomingFaxes,
  blockCallerIdConfigValue:state.AppState.boxDetails.blockCallerIdConfigValue,
  portConfigTemplates: state.AppState.boxDetails.portConfigTemplates,
  currentSelectedPortConfigTemplate: state.UIState.epikBoxDetails.selectedPortConfigTemplate,
  portConfigChangesMade: state.UIState.epikBoxDetails.portConfigChangesMade

});

const mapDispatchToProps = dispatch => ({
  editNumberFieldChange: (name, value) => dispatch(editNumberFieldChangeAction(name, value)),
  enableDisablePort: payload => dispatch(enableDisablePort(payload)),
  getNumberByID: (token, id) => dispatch(getNumberByID(token, id)),
  getAlarmRelay: (token, bid, portNumber) => dispatch(getAlarmRelay(token, bid, portNumber)),
  getSelectedPortModal: type => dispatch(getSelectedPortModal(type)),
  editAssignedNumber: id => dispatch(editAssignedNumber(id)),
  getAddress: (token, numId) => dispatch(getAddress(token, numId)),
  removeNumberAddress: (token, id, body) =>
    dispatch(ProvisioningActions.removeNumberAddress(token, id, body)),
  obiRebootRequired: (token, id, payload) => dispatch(obiRebootRequired(token, id, payload)),
  rebootObi: (token, deviceId) => dispatch(rebootObi(token, deviceId)),
  getPortCallHistory: (token, bid, portNumber) =>
    dispatch(getPortCallHistory(token, bid, portNumber)),
  getObiSystemStatus: (token, bid, portNumber) =>
    dispatch(getObiSystemStatus(token, bid, portNumber)),
  getPhysicalStatus: (token, bid, portNumber) =>
    dispatch(getPhysicalStatus(token, bid, portNumber)),
  getGateways: token => dispatch(getGateways(token)),
  updateAddress: (token, numId, body) => dispatch(updateAddress(token, numId, body)),
  cancelAddNumber: () => dispatch(cancelAddNumber()),
  assignRouteInfo: (token, numId) => dispatch(assignRouteInfo(token, numId)),
  editNumberCancel: () => dispatch(editNumberCancel()),
  portConfig: (token, body) => dispatch(portConfig(token, body)),
  getPortValues: (token, obiId, values) => dispatch(getPortValues(token, obiId, values)),
  getAssignedNumbers: (token, cid, uid, priStatus) =>
    dispatch(getAssignedNumbers(token, cid, uid, priStatus)),
  updateNumber: (token, number) => dispatch(updateNumber(token, number)),
  forceFixNumber: (token, nid, bid) => dispatch(forceFixNumber(token, nid, bid)),
  getEpikBoxData: (token, boxId) => dispatch(getEpikBoxData(token, boxId)),
  selectPort: port => dispatch(selectBoxDetailsPort(port)),
  clearPortConfigChangesMade: () => dispatch(clearPortConfigChangesMade()),
  setPortConfigChangesMade: (changesMade) => dispatch(setPortConfigChangesMade(changesMade)),
  trunkPortConfig: (token, body,showToast) => dispatch(trunkPortConfig(token, body,showToast)),
  boundForwardNumber: (token, bid, body) => dispatch(boundForwardNumber(token, bid, body)),
  boundRemoveNumber: (token, bid, body) => dispatch(boundRemoveNumber(token, bid, body)),
  updateAlarmProtocol: (token, bid, body) => dispatch(updateAlarmProtocol(token, bid, body)),
  removeAlarmProtocolSettings: (token, bid, body) =>
    dispatch(removeAlarmProtocolSettings(token, bid, body)),
  assignAction: description => dispatch(assignAction(description)),
  unassignAction: description => dispatch(unassignAction(description)),
  enableAction: description => dispatch(enableAction(description)),
  disableAction: description => dispatch(disableAction(description)),
  changeAction: description => dispatch(changeAction(description)),
  sendBulkActionsToApi: () => dispatch(sendBulkActionsToApi()),
  clearAddress: () => dispatch(ProvisioningActions.clearAddress()),
  updateObi: (token, obi, epikBoxUser, numId) =>
    dispatch(updateEpikBoxObi(token, obi, epikBoxUser, numId)),
  addNote: (token, id, note) => dispatch(addNote(token, id, note)),
  updateAdvanceModemConfigurations: (token, bId, payload) =>
    dispatch(updateAdvanceModemConfigurations(token, bId, payload)),
  updateNumberRouteAndTrunk: (token, bid) =>
  dispatch(updateNumberRouteAndTrunk(token, bid)),
  selectObi: obi => dispatch(selectBoxDetailsObi(obi)),
  setSelectedPortConfigTemplate: payload => dispatch(setSelectedPortConfigTemplate(payload)),
  getCompanyTollFreeNumbers: (token, companyId)  => dispatch(getCompanyTollFreeNumbers(token, companyId)),
  getObiCallerOverRide: (token, bid,selectedNumber,overrideFlag)  => dispatch(getObiCallerOverRide(token, bid,selectedNumber,overrideFlag)),
  getPortConfigTemplates: (token, dc, value) => dispatch(getPortConfigTemplates(token, dc, value)),
  checkSameUserkLockStatus: (token, bid) => dispatch(checkSameUserkLockStatus(token, bid)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectedPortPanel);
